<template>
  <el-dialog
    v-model="_isShow"
    width="90%"
    height="100vh"
    top="0"
    lock-scroll
    center
    show-close
    destroy-on-close
    :title="$t('Scan barcode')"
  >
    <LocationScan :operationType="operationType" @validate:locationId="handleScanResult" />
  </el-dialog>
</template>

<script lang="ts">
import BarcodeSymbologiesSelection from '@/components/BarcodeSymbologiesSelection.vue'
import LocationScan from '@/components/LocationScan.vue'
import ScanArea from '@/components/svg/ScanArea.vue'
import { Options, Vue } from 'vue-class-component'
import { PropSync, Prop } from 'vue-property-decorator'

@Options({
  components: {
    ScanArea,
    BarcodeSymbologiesSelection,
    LocationScan,
  },
  emits: ['validate:locationId', 'update:isShow'],
  name: 'LocationScanDialog',
})
export default class LocationScanDialog extends Vue {
  @Prop({ type: String }) readonly operationType?: string
  @PropSync('isShow', { type: Boolean }) _isShow!: boolean

  closeLocationScanDialog() {
    this._isShow = false
  }

  handleScanResult(text: string) {
    this.$emit('validate:locationId', text)
  }
}
</script>
